import React, { useEffect, useRef, useState } from "react";
import { Select } from "antd";
import "./Tabs.scss";
import { ReactComponent as DownArrow } from "../../assets/Icons/DownArrow.svg";

const Tabs = ({
  options = [],
  onChange,
  classname = "",
  height,
  active,
  showSelector = true, // default to true so behavior is consistent with SegmentedTabs
  selectorWidth = "100%",
  selectorBreakpoint = 600,
}) => {
  const tabsRef = useRef([]);
  const [indicatorStyle, setIndicatorStyle] = useState({ width: 0, left: 0 });
  const [isSmallScreen, setIsSmallScreen] = useState(
    typeof window !== "undefined"
      ? window.innerWidth <= selectorBreakpoint
      : false
  );

  // 📌 Handle screen size changes
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= selectorBreakpoint);
    };
    handleResize(); // Initialize on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [selectorBreakpoint]);

  // 📌 Set indicator position based on active tab
  useEffect(() => {
    const updateIndicator = () => {
      const activeIndex = options.findIndex((opt) => opt.value === active);
      const activeTab = tabsRef.current[activeIndex];
      if (activeTab && (!isSmallScreen || !showSelector)) {
        const { offsetWidth, offsetLeft } = activeTab;
        setIndicatorStyle({ width: offsetWidth, left: offsetLeft });
      }
    };

    const raf = requestAnimationFrame(updateIndicator);
    return () => cancelAnimationFrame(raf);
  }, [active, options, isSmallScreen, showSelector]);

  // 📌 Show Select on small screen
  if (showSelector && isSmallScreen) {
    return (
      <Select
        value={active}
        onChange={onChange}
        options={options.map((opt) => ({
          label: opt.label,
          value: opt.value,
        }))}
        className={`responsive-tab-select ${classname}`}
        style={{ width: selectorWidth }}
        suffixIcon={<DownArrow />}
      />
    );
  }

  // 📌 Show standard tab layout
  return (
    <div
      className={`segmented-tabs-new ${classname}`}
      style={{ height: height || "auto" }}
    >
      <div className="indicator" style={indicatorStyle} />
      {options.map((opt, i) => (
        <button
          key={opt.value}
          ref={(el) => (tabsRef.current[i] = el)}
          className={`tab ${opt.value === active ? "active" : ""}`}
          onClick={() => onChange?.(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
